module.exports = __webpack_public_path__ + "img/目标3.1604dafc.png";